/**
 * TODO: The functionality in this file is duplicated in
 * consumer-rx-form-reset.js. Any changes to this file should be duplicated
 * there until such a time when consumer-rx-form is updated to somehow reuse
 * the functionality in this module.
 */
(function (window, document) {
  const form = document.getElementById('product-option-form');
  // If no rx form is found, exit early.
  if (!form) return;
  const steps = Array.from(form.querySelectorAll('[data-product-opiton-step]'));

  init();

  /**
   * Instantiate automatic form reset functionality.
   */
  function init() {
    // Reset the form when the modal is closed.
    window.componentEvents.on('modal-change', (data) => {
      if (data.id === 'product-option-modal' && data.action === 'close') {
        form.reset();
        window.componentEvents.emitEvent('product-option-form-reset');
      }
    });
  }
})(window, document);

